import React, { FC } from "react";
import { COLOR_GREY_6 } from "../colors";
import { IconType } from "./types";

export const HouseIcon: FC<IconType> = ({ color = COLOR_GREY_6 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4704 3.06382C12.1624 2.97889 11.8376 2.97889 11.5296 3.06382C11.172 3.16242 10.8709 3.40312 10.6306 3.59522L10.5634 3.64876L4.38948 8.53822C4.05051 8.80607 3.75188 9.04205 3.52935 9.34841C3.33406 9.61727 3.18858 9.92015 3.10006 10.2422C2.99919 10.6091 2.9996 10.994 3.00006 11.4309L3.00012 18.1865C3.00011 18.6696 3.00009 19.0864 3.02764 19.4296C3.05671 19.7919 3.12089 20.1523 3.2944 20.499C3.55326 21.0163 3.9663 21.4369 4.47433 21.7005C4.81487 21.8772 5.16876 21.9425 5.52456 21.9721C5.86167 22.0002 6.27094 22.0001 6.74536 22.0001H17.2546C17.7291 22.0001 18.1383 22.0002 18.4754 21.9721C18.8312 21.9425 19.1851 21.8772 19.5257 21.7005C20.0337 21.4369 20.4467 21.0163 20.7056 20.499C20.8791 20.1523 20.9433 19.7919 20.9724 19.4296C20.9999 19.0864 20.9999 18.6696 20.9999 18.1866L20.9999 11.4309C21.0004 10.994 21.0008 10.6091 20.8999 10.2422C20.8114 9.92015 20.6659 9.61727 20.4706 9.34841C20.2481 9.04205 19.9495 8.80607 19.6105 8.53822L13.4366 3.64876L13.3694 3.59523C13.1291 3.40312 12.828 3.16242 12.4704 3.06382ZM9.30005 14.3023V20.1673H14.7V14.3023C14.7 13.7891 14.7 13.5325 14.6019 13.3364C14.5156 13.164 14.3779 13.0238 14.2086 12.9359C14.0161 12.8361 13.764 12.8361 13.26 12.8361H10.74C10.236 12.8361 9.98397 12.8361 9.79145 12.9359C9.62211 13.0238 9.48443 13.164 9.39814 13.3364C9.30005 13.5325 9.30005 13.7891 9.30005 14.3023Z"
      fill={color}
    />
  </svg>
);
